import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'

/**
 * Создает хэш данных объекта, сортируя его свойства по алфавиту.
 * Свойства вложенных объектов НЕ сортируются.
 *
 * Передать можно как объект, так и результат Object.entries(obj).
 *
 * Можно использовать для сравнения наборов URL query параметров.
 */
export function makeObjectHash(obj: AnyObject | [string, unknown][]): string {
    const entries: [string, unknown][] = Array.isArray(obj) ? obj : Object.entries(obj)
    return JSON.stringify(
        entries.sort(
            ([keyA], [keyB]) => keyA.localeCompare(keyB)
        )
    )
}
